import { Capacitor } from '@capacitor/core';
import packageJson from '../../package.json'; // ✅ Import package.json

// ✅ Use environment variable with fallback
const API_BASE_URL = `${process.env.REACT_APP_BACKEND || 'http://localhost:4000'}/astro`;

const getCurrentVersion = async () => {
  try {
    if (Capacitor.isNativePlatform()) {
      // Mobile app - get from Capacitor App plugin
      const { App } = await import('@capacitor/app');
      const appInfo = await App.getInfo();
      return appInfo.version;
    } else {
      // Web browser - get from package.json
      return packageJson.version; // ✅ Returns "1.1.0"
    }
  } catch (error) {
    console.error(' Failed to get app version:', error);
    return '1.0.0'; // Fallback
  }
};

const openPlayStore = async (playStoreUrl) => {
  try {
    console.log('🔗 Opening Play Store:', playStoreUrl);
    
    if (Capacitor.isNativePlatform()) {
      const { Browser } = await import('@capacitor/browser');
      await Browser.open({ url: playStoreUrl });
    } else {
      window.open(playStoreUrl, '_blank');
    }
  } catch (error) {
    console.error(' Failed to open Play Store:', error);
    window.open(playStoreUrl, '_blank');
  }
};

/**
 * Check for updates - Returns update info
 */
export const checkForUpdates = async () => {
  try {
    console.log('🔍 Checking for Play Store updates...');
    console.log('🌐 API Base URL:', API_BASE_URL); // ✅ Debug log

    const currentVersion = await getCurrentVersion();
    console.log('📱 Current app version:', currentVersion);

    const response = await fetch(`${API_BASE_URL}/app-version`);
    const data = await response.json();
    
    if (!data.success) {
      console.error(' Failed to fetch version info');
      return null;
    }

    console.log('📦 Server response:', data);

    const { latestVersion, playStoreUrl, mandatory, releaseNotes } = data;

    if (latestVersion !== currentVersion) {
      console.log(`🆕 Update available: ${currentVersion} → ${latestVersion}`);
      
      return {
        updateAvailable: true,
        currentVersion,
        latestVersion,
        playStoreUrl,
        mandatory,
        releaseNotes,
        openPlayStore: () => openPlayStore(playStoreUrl)
      };
    } else {
      console.log('✅ App is up to date');
      return null;
    }
  } catch (error) {
    console.error(' Update check failed:', error);
    return null;
  }
};
